module.exports = __webpack_public_path__ + "media/images/line_chart_primary_axis-1250a508e5c9325730b60684fe726fe3.png";